import React, { useState, useEffect } from 'react';
import { StandardURL } from '../services/constants';

// ─── Inline Styles for Dark Theme ──────────────────────────────────────────────
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:wght@300;400;500;600&display=swap');

  .admin-wrapper {
    background: #0a0a0a;
    color: #f0f0f0;
    min-height: 100vh;
    padding: 3rem 2rem;
    font-family: 'DM Sans', sans-serif;
  }
  .admin-container {
    max-width: 1000px;
    margin: 0 auto;
  }
  .admin-card {
    background: #111111;
    border: 1px solid #2a2a2a;
    border-radius: 8px;
    padding: 2.5rem;
    margin-bottom: 2rem;
  }
  .admin-title {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 2.5rem;
    letter-spacing: 0.06em;
    margin-bottom: 1.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .admin-title span {
    color: #e8ff3c; /* Yellow accent */
  }
  .msg-box {
    padding: 1rem;
    background: rgba(232, 255, 60, 0.1);
    color: #e8ff3c;
    border: 1px solid rgba(232, 255, 60, 0.2);
    border-radius: 6px;
    margin-bottom: 1.5rem;
    font-size: 0.9rem;
  }
  .info-box {
    padding: 1rem;
    background: rgba(255, 255, 255, 0.05);
    color: #f0f0f0;
    border: 1px solid #2a2a2a;
    border-radius: 6px;
    margin-bottom: 2rem;
    font-size: 0.9rem;
    text-align: center;
  }
  
  /* Form Styles */
  .admin-form label {
    display: block;
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: #666;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }
  .admin-form input {
    width: 100%;
    background: #1a1a1a;
    border: 1px solid #2a2a2a;
    color: #f0f0f0;
    border-radius: 6px;
    padding: 0.75rem 1rem;
    font-size: 0.9rem;
    font-family: 'DM Sans', sans-serif;
    outline: none;
    transition: border-color 0.2s;
  }
  .admin-form input:focus {
    border-color: #e8ff3c;
  }
  .form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
    margin-bottom: 1.5rem;
  }
  .btn-submit {
    background: #e8ff3c;
    color: #000;
    border: none;
    border-radius: 4px;
    padding: 0.85rem 2rem;
    font-family: 'DM Sans', sans-serif;
    font-weight: 600;
    font-size: 0.95rem;
    cursor: pointer;
    transition: opacity 0.2s;
    width: 100%;
  }
  .btn-submit:hover:not(:disabled) {
    opacity: 0.85;
  }
  .btn-submit:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  .btn-cancel {
    background: transparent;
    color: #f0f0f0;
    border: 1px solid #666;
    border-radius: 4px;
    padding: 0.85rem 2rem;
    font-family: 'DM Sans', sans-serif;
    font-weight: 600;
    font-size: 0.95rem;
    cursor: pointer;
    transition: all 0.2s;
    width: 100%;
    margin-top: 1rem;
  }
  .btn-cancel:hover {
    background: rgba(255, 255, 255, 0.05);
    border-color: #f0f0f0;
  }

  /* Table Styles */
  .admin-table-wrap {
    overflow-x: auto;
  }
  .admin-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
  }
  .admin-table th {
    padding: 1rem;
    border-bottom: 1px solid #2a2a2a;
    color: #666;
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }
  .admin-table td {
    padding: 1rem;
    border-bottom: 1px solid #1a1a1a;
    vertical-align: middle;
    font-size: 0.9rem;
  }
  .admin-table tr:hover {
    background: rgba(255, 255, 255, 0.02);
  }
  .accent-text {
    color: #e8ff3c;
    font-family: monospace;
  }
  .action-buttons {
    display: flex;
    gap: 0.5rem;
    justify-content: flex-end;
  }
  .btn-edit {
    background: transparent;
    color: #4da6ff;
    border: 1px solid rgba(77, 166, 255, 0.3);
    padding: 0.4rem 0.8rem;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.75rem;
    font-weight: 600;
    transition: all 0.2s;
  }
  .btn-edit:hover {
    background: rgba(77, 166, 255, 0.1);
    border-color: #4da6ff;
  }
  .btn-delete {
    background: transparent;
    color: #ff4545;
    border: 1px solid rgba(255, 69, 69, 0.3);
    padding: 0.4rem 0.8rem;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.75rem;
    font-weight: 600;
    transition: all 0.2s;
  }
  .btn-delete:hover {
    background: rgba(255, 69, 69, 0.1);
    border-color: #ff4545;
  }
  .social-link {
    color: #e8ff3c;
    text-decoration: none;
    display: block;
    font-size: 0.85rem;
    margin-bottom: 0.2rem;
  }
  .social-link:hover {
    text-decoration: underline;
  }
  
  @media (max-width: 768px) {
    .form-row { grid-template-columns: 1fr; gap: 0; }
  }
`;

const initialFormState = {
  whatsapp: '',
  instagram: '',
  facebook: '',
  x: '',
  youtube: '',
  snapchat: '',
  beatstars: '' // Added beatstars here
};

const SocialMediaManager = () => {
  const token = localStorage.getItem("token");

  // State
  const [socialMediaList, setSocialMediaList] = useState([]);
  const [formData, setFormData] = useState(initialFormState);
  const [editingId, setEditingId] = useState(null); 
  
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  // Fetch data on mount
  useEffect(() => {
    fetchSocialMedia();
  }, []);

  const fetchSocialMedia = async () => {
    try {
      const response = await fetch(`${StandardURL}/iMusic/user/socialmedia/listadmin`, {
        headers: {
          'Authorization': `Bearer ${token}` 
        }
      });
      const data = await response.json();
      
      const socialArray = Array.isArray(data?.response) 
        ? data.response 
        : (Array.isArray(data) ? data : []);
        
      setSocialMediaList(socialArray);
    } catch (error) {
      console.error('Error fetching social media:', error);
      setSocialMediaList([]); 
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  // Handle Add & Update
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    const isUpdating = editingId !== null;
    
    const endpoint = isUpdating 
      ? `${StandardURL}/iMusic/user/socialmedia/update/${editingId}`
      : `${StandardURL}/iMusic/user/socialmedia/add`;

    try {
      const response = await fetch(endpoint, {
        method: isUpdating ? 'PUT' : 'POST', 
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setMessage(`Social media links ${isUpdating ? 'updated' : 'added'} successfully! ✅`);
        setFormData(initialFormState); 
        setEditingId(null);            
        fetchSocialMedia();            
      } else {
        const errorData = await response.json().catch(() => ({}));
        setMessage(errorData.error || errorData.message || 'Failed to save social media links.');
      }
    } catch (error) {
      console.error('Error saving data:', error);
      setMessage('An error occurred while saving.');
    } finally {
      setLoading(false);
    }
  };

  // Populate form for editing
  const handleEdit = (social) => {
    setEditingId(social.id);
    setFormData({
      whatsapp: social.whatsapp || '',
      instagram: social.instagram || '',
      facebook: social.facebook || '',
      x: social.x || '',
      youtube: social.youtube || '',
      snapchat: social.snapchat || '',
      beatstars: social.beatstars || '' // Populating beatstars for edit mode
    });
    setMessage('Edit mode active. Update the form and save.');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Cancel edit mode
  const handleCancelEdit = () => {
    setEditingId(null);
    setFormData(initialFormState);
    setMessage('');
  };

  // Handle Delete
  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete these links?')) return;

    try {
      const response = await fetch(`${StandardURL}/iMusic/user/socialmedia/delete/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        setMessage('Social media record deleted successfully. 🗑️');
        if (editingId === id) handleCancelEdit();
        fetchSocialMedia(); 
      } else {
        setMessage('Failed to delete record.');
      }
    } catch (error) {
      console.error('Error deleting record:', error);
      setMessage('An error occurred while deleting.');
    }
  };

  // Logic to determine if we should show the form or hide it
  const hasExistingRecord = socialMediaList.length > 0;
  const showForm = !hasExistingRecord || editingId !== null;

  return (
    <div className="admin-wrapper">
      <style>{styles}</style>
      
      <div className="admin-container">
        
        {message && <div className="msg-box">{message}</div>}

        {/* --- ADD / UPDATE FORM RENDERING LOGIC --- */}
        {showForm ? (
          <div className="admin-card">
            <h2 className="admin-title">
              {editingId ? (<span>UPDATE LINKS</span>) : (<span>ADD LINKS</span>)}
            </h2>
            
            <form onSubmit={handleSubmit} className="admin-form">
              <div className="form-row">
                <div>
                  <label>WhatsApp</label>
                  <input 
                    type="text" 
                    name="whatsapp"
                    placeholder="e.g. +1234567890 or wa.me link"
                    value={formData.whatsapp}
                    onChange={handleInputChange} 
                  />
                </div>
                <div>
                  <label>Instagram</label>
                  <input 
                    type="url" 
                    name="instagram"
                    placeholder="https://instagram.com/..."
                    value={formData.instagram}
                    onChange={handleInputChange} 
                  />
                </div>
              </div>

              <div className="form-row">
                <div>
                  <label>Facebook</label>
                  <input 
                    type="url" 
                    name="facebook"
                    placeholder="https://facebook.com/..."
                    value={formData.facebook}
                    onChange={handleInputChange} 
                  />
                </div>
                <div>
                  <label>X (Twitter)</label>
                  <input 
                    type="url" 
                    name="x"
                    placeholder="https://x.com/..."
                    value={formData.x}
                    onChange={handleInputChange} 
                  />
                </div>
              </div>

              <div className="form-row">
                <div>
                  <label>YouTube</label>
                  <input 
                    type="url" 
                    name="youtube"
                    placeholder="https://youtube.com/..."
                    value={formData.youtube}
                    onChange={handleInputChange} 
                  />
                </div>
                <div>
                  <label>Snapchat</label>
                  <input 
                    type="url" 
                    name="snapchat"
                    placeholder="https://snapchat.com/add/..."
                    value={formData.snapchat}
                    onChange={handleInputChange} 
                  />
                </div>
              </div>

              {/* Added Beatstars Row */}
              <div className="form-row">
                <div>
                  <label>Beatstars</label>
                  <input 
                    type="url" 
                    name="beatstars"
                    placeholder="https://beatstars.com/..."
                    value={formData.beatstars}
                    onChange={handleInputChange} 
                  />
                </div>
                <div>
                   {/* Empty div to maintain the 2-column CSS grid layout */}
                </div>
              </div>

              <button type="submit" className="btn-submit" disabled={loading}>
                {loading ? 'Saving...' : (editingId ? 'Update Links' : 'Save Links')}
              </button>
              
              {editingId && (
                <button type="button" className="btn-cancel" onClick={handleCancelEdit}>
                  Cancel Edit
                </button>
              )}
            </form>
          </div>
        ) : (
          <div className="info-box">
            Social media links are already configured. To make changes, please edit the existing record below.
          </div>
        )}

        {/* --- SOCIAL MEDIA LIST --- */}
        <div className="admin-card">
          <h2 className="admin-title">MANAGE <span>SOCIAL MEDIA</span></h2>
          
          {socialMediaList.length === 0 ? (
            <p style={{ color: '#666' }}>No social media records found.</p>
          ) : (
            <div className="admin-table-wrap">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Active Links</th>
                    <th style={{ textAlign: 'right' }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {socialMediaList.map((social) => (
                    <tr key={social.id}>
                      <td className="accent-text">#{social.id}</td>
                      <td>
                        {social.whatsapp && <a href={social.whatsapp} target="_blank" rel="noreferrer" className="social-link">WhatsApp</a>}
                        {social.instagram && <a href={social.instagram} target="_blank" rel="noreferrer" className="social-link">Instagram</a>}
                        {social.facebook && <a href={social.facebook} target="_blank" rel="noreferrer" className="social-link">Facebook</a>}
                        {social.x && <a href={social.x} target="_blank" rel="noreferrer" className="social-link">X (Twitter)</a>}
                        {social.youtube && <a href={social.youtube} target="_blank" rel="noreferrer" className="social-link">YouTube</a>}
                        {social.snapchat && <a href={social.snapchat} target="_blank" rel="noreferrer" className="social-link">Snapchat</a>}
                        {/* Render Beatstars link */}
                        {social.beatstars && <a href={social.beatstars} target="_blank" rel="noreferrer" className="social-link">Beatstars</a>} 
                        
                        {/* Fallback updated to include beatstars */}
                        {(!social.whatsapp && !social.instagram && !social.facebook && !social.x && !social.youtube && !social.snapchat && !social.beatstars) && (
                          <span style={{ color: '#666' }}>No links configured</span>
                        )}
                      </td>
                      <td>
                        <div className="action-buttons">
                          <button 
                            className="btn-edit"
                            onClick={() => handleEdit(social)}
                          >
                            ✎ Edit
                          </button>
                          <button 
                            className="btn-delete"
                            onClick={() => handleDelete(social.id)}
                          >
                            ✕ Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

export default SocialMediaManager;